/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, createContext, useContext } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import 'moment-timezone';

// local imports
import * as serviceWorker from '../serviceWorker';
import AuthService from '../services/AuthService';
import ProviderService from '../services/ProviderService';
import FullPageLoader from '../components/general/FullPageLoader';
import GeneralService from '../services/GeneralService';
// import OrganisationService from '../services/OrganisationService';

// export the AuthContext
export const AuthContext = createContext();

// AuthContext Provider
export default ({ children }) => {

    // variables
    const version = "2.5.1";
    const NEXT_APP_URL="https://umangwellness.com";

    // states
    const [user, setUser] = useState({ username: "", email: "", profileImage: "", timezone: "", selectedRole: "", roles: [], guideTakenFor: [], isApproved: false });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [timeZones, setTimeZones] = useState([]);
    const [selectedTimeZone, setSelectedTimeZone] = useState({ label: "", offset: moment().format("Z"), dst_offset: moment().format("Z"), value: [], isDST: false });
    const [isGoogleSignIn, setIsGoogleSignIn] = useState(false);
    const [maintenance, setMaintenance] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [userApprovalStatus, setUserApprovalStatus] = useState(false);

    useEffect(() => {
        if(user.selectedRole) {
            document.cookie = "selectedRole=" + user.selectedRole + ";domain=umangwellness.com;path=/";
        } else {
            document.cookie = "selectedRole=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
        window.localStorage.setItem('selectedRole', user.selectedRole);
    }, [user.selectedRole]);

    useEffect(() => {
        window.localStorage.setItem('selectedTimeZone', JSON.stringify(selectedTimeZone));
    }, [selectedTimeZone])

    useEffect(() => {
        window.localStorage.setItem('version', version);
        GeneralService.getTimeZones().then(data => {
            let tz = moment.tz.guess();
            let temp = data.timeZones.find(item => item.value.includes(tz));
            temp.isDST = moment().isDST();
            setSelectedTimeZone(temp);
            setTimeZones(data.timeZones);
        });
        GeneralService.getMaintenanceStatus()
            .then(data => {
                setMaintenance(data.maintenance);
                if (data.appVersion !== version) {
                    setUpdateModal(true);
                    console.log("version updated");
                    serviceWorker.unregister();
                }
                AuthService.isAuthenticated()
                    .then(data => {
                        let selectedRole = data.user.roles.length ? data.user.roles[0] : '';
                        const pathname = window.location.pathname.split('/');
                        if (pathname.length && pathname[1] === 'counsellor') {
                            selectedRole = 'provider';
                        } else if (pathname.length && pathname[1] === 'client') {
                            selectedRole = 'client';
                        }
                        if (data.isGoogleSignIn) {
                            setIsGoogleSignIn(true);
                        }
                        setIsAuthenticated(data.isAuthenticated);
                        setUser({ ...data.user, selectedRole: selectedRole });
                        getUserApprovalStatus(selectedRole);
                        setTimeout(() => setIsLoaded(true), 2500);
                    })
                    .catch(error => {
                        setIsAuthenticated(false)
                        setUser({ username: "", email: "", profileImage: "", selectedRole: "", roles: [], timezone: "", guideTakenFor: [] });
                        setTimeout(() => setIsLoaded(true), 2500);
                    })
            })
    }, [])

    const getUserApprovalStatus = (selectedRole) => {
        if (selectedRole === 'provider') {
            ProviderService.getApprovalStatus().then(data => {
                // console.log('userApprovalStatus', data);
                setUserApprovalStatus(data.isApproved);
            })
        }
        //  else if (selectedRole === 'organisation_admin') {
        //     OrganisationService.getApprovalStatus().then(data => {
        //         console.log('userApprovalStatus', data);
        //         setUserApprovalStatus(data.isApproved);
        //     })
        // }
    }

    const updateSite = () => {
        window.location.reload();
    }

    return (
        !isLoaded ?
            <FullPageLoader /> :
            <AuthContext.Provider value={{ user, setUser, isAuthenticated, setIsAuthenticated, maintenance, setMaintenance, version, NEXT_APP_URL, isGoogleSignIn, setIsGoogleSignIn, timeZones, selectedTimeZone, setSelectedTimeZone, userApprovalStatus, setUserApprovalStatus }}>
                {children}
                <Modal size="sm" isOpen={updateModal} backdrop={true}>
                    <ModalHeader close={<span></span>}><span style={{ fontSize: "1.2rem", fontWeight: "700" }}>New update</span></ModalHeader>
                    <ModalBody>Umang Wellness has been updated, please click on button below to update it in your browser and enjoy new features.</ModalBody>
                    <ModalFooter><Button onClick={() => updateSite()}>Update</Button></ModalFooter>
                </Modal>
            </AuthContext.Provider>
    )
}